import { compose } from "recompose";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { withActions } from "core/redux/hoc";
import { signOut } from "modules/user/auth/actions";
import { insider } from "routes/paths";
import View from "./View";

export default compose(
  connect(void 0, {
    pushToInsiderDashboard: () => push(insider.insiderMain),
    pushToInsiderProfile: () => push(insider.insiderDashboardProfile),
    pushToInsiderReferral: () => push(insider.insiderReferral),
    pushToInsiderReviews: () => push(insider.reviews)
  }),
  withActions({
    onSignOut: () => signOut
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/common/insider/Overlay/Menu/Provider.js